



























































import {Component, Ref, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import {cloneDeep, isEqual} from "lodash";
import {GroupsApplicationItem} from '@/store/push/groups_application/types';
import {notifyConfirm, notifyDelete, notifyError} from '@/utils/notify-helper';
import PushApplicationsTable from "@/components/Push/Applications/PushApplicationsTable.vue";
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";

Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {PushApplicationsTable},
})
export default class PushGroupsApplication extends Vue {
  @Ref('validator') validator: any;

  @Action('getGroupsApplicationItem') actionGetItem: any;
  @Action('saveGroupsApplicationItem') actionSave: any;
  @Action('deleteGroupsApplicationItem') actionDelete: any;
  @Action("getPushApplications") actionGetApplications: any;
  @Action("actionLog") actionLog: any;

  @Getter("pushApplications") applicationsList!: any[];

  private item: GroupsApplicationItem = this.defaultItem();
  private itemSaved: GroupsApplicationItem = this.defaultItem();
  private logObject: ActionLog = {};

  async created(): Promise<void> {
    this.actionGetApplications();
    try {
      if (this.$route.params.id) {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Push-applications group",
          addititional_info: {ID: this.$route.params.id}
        }
        const data = await this.actionGetItem(this.$route.params.id);
        await this.actionLog(this.logObject);
        this.item.applications_ids = data?.applications.map((el: any) => el.id);
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
      }
    } catch (error) {
      this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(error);
    }
  }

  defaultItem(): GroupsApplicationItem {
    return {
      name: '',
      applications_ids: []
    }
  }

  back(): void {
    this.$router.push('/push/groups_applications/');
  }

  onSaveItem(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid:boolean = await this.validator.validate();
      if (valid) {
        try {
          delete this.item.applications;
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: this.$route.params.id ? "Editing" : "Creation",
            action_status: "success",
            object_type: "Push-applications group",
            addititional_info: getTranslatedParams(this.item)
          }
          await this.actionSave(this.item);
          await this.actionLog(this.logObject);
          this.itemSaved = this.item;
          resolve()
          this.back();
        } catch (error) {
          this.actionLog({...this.logObject, action_status: "failed"});
          reject()
          notifyError(error);
        }
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors)
        }, 100);
      }
    })
  }

  async onDeleteItem(): Promise<void> {
    let isConfirm:boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "Push-applications group",
          addititional_info: {ID: this.item.id}
        }
        await this.actionDelete(this.item)
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  get filteredApplicationsList() {
    return this.item.applications_ids
        ? this.applicationsList.filter(app => !this.item.applications_ids?.includes(app.id))
        : this.applicationsList;
  }

  getApplicationIdByName(name: string): number {
    return this.applicationsList.find((e: any) => e.name === name)?.id;
  }

  deleteAction(name: string){
    const id = this.getApplicationIdByName(name);
    const idIndex = this.item.applications_ids?.indexOf(id) || 0;
    if (idIndex !== -1) this.item.applications_ids?.splice(idIndex, 1);
  }

  addApplication(name: string){
    const id = this.getApplicationIdByName(name);
    this.item.applications_ids?.push(id);
  }

  changeOrder(applications: any) {
    if (!applications?.length) return;
    const appNames: string[] = applications?.map((el: any) => el.name);
    const ids: number[] = [];
    appNames.forEach((name: string) => {
      ids.push(this.getApplicationIdByName(name));
    });
    this.item.applications_ids = ids;
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }
}
